export const environment = {
  minAutoCompleteLength: 4,
  production: true,
  dateFormat: 'dd-MMM-yyyy',
  dateTimeFormat: 'dd-MMM-yyyy HH:mm',
  idleLogoutTime: '#{FE.IdleLogoutTime}#',
  defaultLanguage: '1', //en
  cipherKey: '123',
  managerRoleId: '#{FE.ManagerRoleId}#',
  selfRelationId: '#{appsettings.SelfRelationId}#',
  recaptcha: {
    siteKey: '#{appsettings.GoogleReCaptcha.SiteKey}#',
  },
  featureFlagKeys: {
    security2FAFlag: {name: 'Genetics.#{_ENV}#.Security2FA', type: 1},
  },
  oidcConfig: {
    clientId: '#{FE.IdentityServer.ClientId}#',
    scope: '#{FE.IdentityServer.Scope}#',
    responseType: '#{FE.IdentityServer.ResponseType}#',
    silentRenew: true,
    useRefreshToken: true,
    logLevel: '#{FE.IdentityServer.LogLevel}#',
    postLoginRoute: '#{FE.IdentityServer.postLoginRoute}#',
    postLogoutRoute: '#{FE.IdentityServer.postLogoutRoute}#',
    unauthorizedRoute: '#{FE.IdentityServer.unauthorizedRoute}#',
    authRequest: 'ClientAPI,secretApi,client_credentials,secretApi',
    maxIdTokenIatOffsetAllowedInSeconds: 180,
  },
  skipCookieConsent: false,
  api: {
    authUrl: '#{FE.IdentityServer.Url}#',
    baseUrl: '#{FE.ClientGw.Url}#',
    resendTokenUrl: 'RequestNewToken',
    config: {
      getCountries: 'Config/GetCountries',
      getRegions: 'Config/GetRegions',
      getCities: 'Config/GetCities',
      getAllSpecialities: 'Config/GetAllSpecialities',
      getConsentPdf: 'Config/GetConsentPdf',
      getOrderStatus: 'Config/GetOrderStatuses',
      getLanguages: 'Config/Languages',
      getLocalizedProperties: 'Config/LocalizedProperties',
      getPatientRelationType: 'Config/GetPatientRelationTypes',
    },
    accessToken: 'connect/token',
    identity: {
      getCustomersByOrganizationId: 'Identity/GetCustomersByOrganizationId',
      getRoles: 'Identity/GetRoles',
      customerAccount: 'Identity/Customer',
      authenticatorSetup: 'Identity/AuthenticatorSetup',
      authenticatorSetupVerify: 'Identity/AuthenticatorSetupVerify',
      authenticatorSetupCancel: 'Identity/AuthenticatorSetupCancel',
    },
    organization: {
      updateCustomerOrganizationStatus: 'Identity/UpdateCustomerOrganizationStatus',
    },
    featureFlag: {
      getFeatureFlag: 'Config/GetFeatureFlag',
    },
    account: {
      addNewCustomer: 'Identity/AddNewCustomer',
      getCustomer: 'Customer',
    },
    customer: {
      register: 'register',
      validateRecaptchaToken: 'ValidateReCaptchaTokenAsync',
    },
    checkout: {
      createOrder: 'Orders/CreateOrder',
      updateOrder: 'Orders/UpdateOrder',
      cancelOrder: 'Orders/CancelOrder',
      updateOrderStatus: 'Orders/UpdateOrderStatus',
      getOrder: 'Orders/Order',
      getOrders: 'Orders/GetOrders',
      getProducts: 'Catalog/GetProducts',
      getCategories: 'Catalog/GetCategories',
      getProductById: 'Catalog/GetProductById',
      getEditOrder: 'Orders/Order/',
      getConsentPdf: 'Orders/GetConsentPdf',
      getOrderPdfResults: 'GetOrderPdfResults',
      downloadOrderPdfResults: 'DownloadOrderPdfResults',
      getSampleTypes: 'Orders/GetSampleTypes',
    },
    user: {
      getCustomerOrganization: 'Identity/GetOrganizationsByCustomerId',
      getAccountConfirmation: 'ConfirmAccount',
      resetPassword: 'PasswordRecoveryConfirm',
      forgotPassword: 'PasswordRecovery',
      changePassword: 'ChangePassword',
      setLanguage: 'SetLanguage',
    },
    header: {
      getCustomerProfile: '/GetCustomerProfile',
      updateCustomerProfile: '/UpdateCustomer',
    },
    static: {
      getStaticPages: 'Config/GetStaticPage/{key}/{languageId}',
    },
  },
  cookie: {
    cookieConsent: '.GEN.CookieConsent',
    cookieExpirationTimeInDays: 2,
    domain: 'localhost',
    sameSite: 'Strict',
  },
  Organization: {
    updateOrganization: 'Organization',
  },
  buildNumber: '#{Build.BuildNumber}#',
  showBuildNumber: '#{showBuildNumber}#',
  showMaintenancePage: '#{showMaintenancePage}#',
  algoliaSearch: {
    applicationId: '#{appsettings.AlgoliaConfig.AppId}#',
    searchApiKey: '#{FE.Algolia.searchApiKey}#',
    productsIndexName: '#{appsettings.AlgoliaConfig.ProductsIndexName}#',
    variantsIndexName: '#{appsettings.AlgoliaConfig.ProductAttributesIndexName}#',
  },
};
